export default "__VITE_ASSET__6654a239__"